/*------------------------------------------------------------------ 
Import styles
------------------------------------------------------------------*/

import './../styles/style.scss';

/*------------------------------------------------------------------
Import Plugins
------------------------------------------------------------------*/

import inView from 'in-view';
import MatchHeight from '@tannerhodges/match-height';

import './wishlist';
import './predictive-search';

import { Notyf } from 'notyf';
import * as SHOP from './shop';
import { $, $$ } from './lib'


// Base notification styles
let notyf = new Notyf({
    duration: 4000,
    dismissible: true,
    icon: false
});


/*------------------------------------------------------------------
Document ready
------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {


    let $sameColumn = $$('.same-column');

    if ($sameColumn) {
        $sameColumn.forEach(column => {
            let previousColumn = column.previousElementSibling;
            previousColumn.innerHTML += column.innerHTML;
            column.remove();
        });
    }

    let $userform = $('.userform');

    if ($userform) {
        $userform.addEventListener('submit', (event) => {
            $userform.classList.add('loading');
        });

        $userform.querySelector('.btn-toolbar').insertAdjacentHTML('beforeend', '<span class="buttonLoader"></span>');
    }

    /*------------------------------------------------------------------
    Show / Hide logic on specific UDF elements if they are present
    ------------------------------------------------------------------*/

    let $info = $('#Info');
    let $message = $('#Message input');

    if ($info && $message) {

        // Hide the info element
        $info.style.display = 'none';

        // Show the info element when the message input is focused
        $message.addEventListener('focus', () => $info.style.display = 'block');
    }



    // Match height on the titles
    MatchHeight.add('.featured-range__slider__item__swatches');

    /*------------------------------------------------------------------
    Import external 
    ------------------------------------------------------------------*/
    if ($('#CouponDiscountForm_CouponDiscountForm')) import('./checkout');
    if ($('.js-faq-grid')) import('./faq-filter');
    if ($('.js-products-grid')) import('./product-filter');
    if ($('.js-resources-grid')) import('./resources-filter');
    if ($('.js-image-library-grid')) import('./image-library-filter');
    if ($('.js-presentation-block')) import('./presentation-block');
    if ($('.js-slider-block')) import('./slider-block');
    if ($('.js-inspiration-slider')) import('./inspiration-slider-block');
    if ($('.js-banner-slider')) import('./banner-slider');
    if ($('.js-product-slider')) import('./product-slider');
    if ($('.featured-slider__slider')) import('./featured-slider');
    if ($('.js-change-swatch-range-block')) import('./range-block');
    if ($('select.dropdown,.js-location-type,.js-sort-results-by')) import('./choices');
    if ($('#ShippingTable')) document.body.classList.add('has-shipping-table');

    /*------------------------------------------------------------------
    Mega menu interactions
    ------------------------------------------------------------------*/

    let hoverTimeout;
    let interacted = false;
    let megamenu = $('.mega-menu');
    let showMegamenus = $$('.js-toggle-mega');
    let hideMegamenus = $$('.js-hide-mega');
    let megamenuItems = $$('.mega-menu__wrap__item');


    if (showMegamenus) {
        showMegamenus.forEach(showMegamenu => {
            showMegamenu.addEventListener('click', (e) => {
                e.preventDefault();
                interacted = true;

                $$('.js-mega-menu-image').forEach(image => {
                    image.setAttribute('src', image.dataset.src);
                });

                megamenuItems.forEach(megamenuItem => megamenuItem.classList.remove('active'));

                if (showMegamenu.dataset.showSubnav === 'true') $(`.mega-menu__wrap__item[data-id="${e.currentTarget.dataset.id}"]`).classList.add('active');

                setTimeout(() => megamenu.classList.add('active'), 10);
            });
        });
    }


    if (hideMegamenus) {
        hideMegamenus.forEach(hideMegamenu => {
            hideMegamenu.addEventListener('click', (e) => {
                clearTimeout(hoverTimeout);
                megamenuItems.forEach(megamenuItem => megamenuItem.classList.remove('active'));
                megamenu.classList.remove('active');
            });
        });
    }

    // document.addEventListener('wheel', (event) => {
    //     console.log('scroll', window.scrollY)

    //     if (Math.abs(event.deltaY) > 5) {
    //         clearTimeout(hoverTimeout);
    //         megamenuItems.forEach(megamenuItem => megamenuItem.classList.remove('active'));
    //         megamenu.classList.remove('active');
    //         document.body.classList.remove('searchActive');
    //     }
    // });

    window.addEventListener('resize', (event) => {
        clearTimeout(hoverTimeout);
        megamenuItems.forEach(megamenuItem => megamenuItem.classList.remove('active'));
        megamenu.classList.remove('active');
    });


    const megaMenu = document.querySelector('.mega-menu')

    document.addEventListener('click', event => {

        const isClickInside = megaMenu.contains(event.target)

        if (!isClickInside && megaMenu.classList.contains('active') && !event.target.classList.contains('js-toggle-mega') && !event.target.parentNode.classList.contains('js-toggle-mega')) {
            clearTimeout(hoverTimeout);
            megamenuItems.forEach(megamenuItem => megamenuItem.classList.remove('active'));
            megamenu.classList.remove('active');
        }
    });


    /*------------------------------------------------------------------
    Animate elements when they come in to view
    ------------------------------------------------------------------*/

    inView('.js-in-view')
        .on('enter', el => { el.classList.add('inView') })


    /*------------------------------------------------------------------
    Animate hot spot elements when they come in to view
    ------------------------------------------------------------------*/

    inView('.js-in-out-view')
        .on('enter', el => { el.classList.add('inView') })
        .on('exit', el => { el.classList.remove('inView') })


    /*------------------------------------------------------------------
    Post Load classname removal
    ------------------------------------------------------------------*/

    $$('.js-postload').forEach(element => {
        element.classList.remove('js-postload');
    });


    /*------------------------------------------------------------------
    Add light theme to search page
    ------------------------------------------------------------------*/

    if (window.location.href.includes('Search')) document.body.dataset.theme = 'light';


    /*------------------------------------------------------------------
    Sticky header  
    ------------------------------------------------------------------*/

    let previousScrollPosition = 0;
    let scrollDelta = 0;
    let header = $('.header');
    let headerHeight = 120;

    const stickyHeader = () => {

        clearTimeout(hoverTimeout);
        megamenuItems.forEach(megamenuItem => megamenuItem.classList.remove('active'));
        megamenu.classList.remove('active');
        document.body.classList.remove('searchActive');

        let st = window.scrollY;
        if (Math.abs(previousScrollPosition - st) <= scrollDelta) return;
        if (st === 0) {
            header.classList.remove('nav-down');
            header.classList.remove('nav-up');
        } else if (st > previousScrollPosition && st > headerHeight) {
            header.classList.remove('nav-down');
            header.classList.add('nav-up');
        } else {
            if (st > headerHeight) {
                header.classList.add('nav-down');
                header.classList.remove('nav-up');
            }
        }
        previousScrollPosition = st;
    }

    window.addEventListener('scroll', stickyHeader);


    /*------------------------------------------------------------------
    Shop
    ------------------------------------------------------------------*/

    document.addEventListener('click', function (event) {



        /**
         * 
         * Outbound link event tracking
         * 
         */
        if (event.target.matches('.js-track-outbound-link')) {

            event.preventDefault();

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: 'outbound_click',
                href: event.target.getAttribute('href'),
                origin: window.location.href
            });

            window.open(event.target.getAttribute('href'), '_blank');
        };


        /**
         * 
         * Go to the stockists page
         * 
         */
        if (event.target.matches('.js-view-item')) {

            event.preventDefault();

            window.location = event.target.getAttribute('href');
        };


        /**
         * 
         * Clear all previously set filters
         * 
         */
        if (event.target.matches('.js-clear-filters')) {

            localStorage.removeItem('oliveri_au_products_sort')
            localStorage.removeItem('oliveri_au_products_query')
            localStorage.removeItem('oliveri_au_products_category')
            localStorage.removeItem('oliveri_au_products_filters')
            localStorage.removeItem('oliveri_au_products_current_page')

        };

        if (event.target.matches('.js-decrease-quantity-checkout')) {

            // Get the ID of the item
            let product = event.target.closest('.quantity');
            let id = product.dataset.id;
            let variation_id = product.dataset.variationId || null;

            // Add a loading state to the sidecart
            if ($('.checkout-step__wrap__sidebar__list')) $('.checkout-step__wrap__sidebar__list').classList.add('loading');
            if ($('.side-cart')) $('.side-cart').classList.add('loading');

            // Add to cart
            SHOP.quickRemove(id, variation_id).then((data) => {

                if (data.code === 400) {
                    // Show a message if there is an error
                    notyf.error({ message: data.message, icon: false });

                    setTimeout(() => {
                        // Remove loading class from the cart
                        if ($('.cart')) $('.cart').classList.remove('loading');

                        // Remove the loading state to the sidecart
                        if ($('.checkout-step__wrap__sidebar__list')) $('.checkout-step__wrap__sidebar__list').classList.remove('loading');
                        if ($('.side-cart')) $('.side-cart').classList.remove('loading');

                    }, 400);

                    return false;
                }

                // Update the sidebar
                SHOP.updateSidecart(data.data);

                // Update the header icon count
                SHOP.updateHeaderIcon(data.data);

                // Update the sidecart if we are on the checkout page
                if (document.body.dataset.segment === 'checkout') SHOP.updateCheckout(data.data);

                // Update the cart if it is present
                if ($('.js-cart')) SHOP.updateCart(data.data);

                // Wait for animations to end before updating content
                setTimeout(() => {

                    // Remove loading class from the cart
                    if ($('.cart')) $('.cart').classList.remove('loading');

                    // Remove the loading state to the sidecart
                    if ($('.checkout-step__wrap__sidebar__list')) $('.checkout-step__wrap__sidebar__list').classList.remove('loading');
                    if ($('.side-cart')) $('.side-cart').classList.remove('loading');

                }, 600);

            }).catch((data) => {
                // Show a message if there is an error
                notyf.error({ message: data.message, icon: false });


                // Wait for animations to end before updating content
                setTimeout(() => {

                    // Remove loading class from the cart
                    if ($('.cart')) $('.cart').classList.remove('loading');

                    // Remove the loading state to the sidecart
                    if ($('.checkout-step__wrap__sidebar__list')) $('.checkout-step__wrap__sidebar__list').classList.remove('loading');
                    if ($('.side-cart')) $('.side-cart').classList.remove('loading');

                }, 600);
            });
        }


        if (event.target.matches('.js-increase-quantity-checkout')) {
            // Get the ID of the item
            let product = event.target.closest('.quantity');
            let id = product.dataset.id;
            let variation_id = product.dataset.variationId || null;

            // Integrate analytics with this action
            SHOP.addItemAnalytics(cart.items, id, 1);

            if ($('.checkout-step__wrap__sidebar__list')) $('.checkout-step__wrap__sidebar__list').classList.add('loading');
            if ($('.side-cart')) $('.side-cart').classList.add('loading');

            // Add to cart
            SHOP.quickAdd(id, variation_id).then((data) => {

                if (data.code === 400) {
                    // Show a message if there is an error
                    notyf.error({ message: data.message, icon: false });

                    setTimeout(() => {
                        // Remove loading class from the cart
                        if ($('.cart')) $('.cart').classList.remove('loading');

                        // Remove the loading state to the sidecart
                        if ($('.checkout-step__wrap__sidebar__list')) $('.checkout-step__wrap__sidebar__list').classList.remove('loading');
                        if ($('.side-cart')) $('.side-cart').classList.remove('loading');

                    }, 400);

                    return false;
                }

                // Update the sidebar
                SHOP.updateSidecart(data.data);

                // Update the header icon count
                SHOP.updateHeaderIcon(data.data);

                // Update the sidecart if we are on the checkout page
                if (document.body.dataset.segment === 'checkout') SHOP.updateCheckout(data.data);

                // Update the cart if it is present
                if ($('.js-cart')) SHOP.updateCart(data.data);

                // Wait for animations to end before updating content
                setTimeout(() => {

                    // Remove loading class from the cart
                    if ($('.cart')) $('.cart').classList.remove('loading');

                    // Remove the loading state to the sidecart
                    if ($('.checkout-step__wrap__sidebar__list')) $('.checkout-step__wrap__sidebar__list').classList.remove('loading');
                    if ($('.side-cart')) $('.side-cart').classList.remove('loading');

                }, 600);

            }).catch((data) => {
                // Show a message if there is an error
                notyf.error({ message: data.message, icon: false });

                setTimeout(() => {
                    // Remove loading class from the cart
                    if ($('.cart')) $('.cart').classList.remove('loading');

                    // Remove the loading state to the sidecart
                    if ($('.checkout-step__wrap__sidebar__list')) $('.checkout-step__wrap__sidebar__list').classList.remove('loading');
                    if ($('.side-cart')) $('.side-cart').classList.remove('loading');

                }, 400);
            });
        }


        /**
         * 
         * Remove an item from the sidecart
         * 
         */
        if (event.target.matches('.js-remove-item-from-sidecart')) {

            // Get the ID of the item
            let id = event.target.dataset.id;

            // Add a loading state to the sidecart
            if ($('.checkout-step__wrap__sidebar__list')) $('.checkout-step__wrap__sidebar__list').classList.add('loading');
            if ($('.side-cart')) $('.side-cart').classList.add('loading');

            // Add removal animation to the item
            if ($(`.checkout-step__wrap__sidebar__list__body__item[data-id="${id}"]`)) $(`.checkout-step__wrap__sidebar__list__body__item[data-id="${id}"]`).classList.add('checkout-step__wrap__sidebar__list__body__item--removed');
            if ($(`.side-cart__tray__body__item[data-id="${id}"]`)) $(`.side-cart__tray__body__item[data-id="${id}"]`).classList.add('side-cart__tray__body__item--removed');


            // Integrate analytics with this action
            SHOP.removeItemAnalytics(cart.items, id, parseInt(event.target.dataset.quantity));

            SHOP.removeAllFromCart(event.target.dataset.removeUrl).then((data) => {

                // Wait for animations to end before updating content
                setTimeout(() => {

                    // Update the sidebar
                    SHOP.updateSidecart(data.data);

                    // Update the header icon count
                    SHOP.updateHeaderIcon(data.data);

                    // Update the sidecart if we are on the checkout page
                    if (document.body.dataset.segment === 'checkout') SHOP.updateCheckout(data.data);

                    // Update the cart if it is present
                    if ($('.js-cart')) SHOP.updateCart(data.data);

                    // Remove the loading state to the sidecart
                    if ($('.checkout-step__wrap__sidebar__list')) $('.checkout-step__wrap__sidebar__list').classList.remove('loading');
                    if ($('.side-cart')) $('.side-cart').classList.remove('loading');

                }, 1200);

            }).catch((data) => {
                // Show a message if there is an error
                notyf.error({ message: data.message, icon: false });
            });
        }


        /**
         * 
         * Remove an item from the cart
         * 
         */
        if (event.target.matches('.js-remove-item-from-cart')) {

            // Get the ID of the item
            let id = event.target.dataset.id;

            // Add loading class to the cart
            $('.cart').classList.add('loading');

            // Add removal animation to the item
            $(`.cart__list__item[data-id="${id}"]`).classList.add('cart__list__item--removed');

            // Get the quantity to simulate a remove all interaction
            let quantity = parseInt(event.target.parentNode.parentNode.querySelector('.quantity__input__field').value);

            // Remove from cart
            SHOP.removeAllFromCart(event.target.dataset.removeUrl).then((data) => {

                // Update the sidebar
                SHOP.updateSidecart(data.data)

                // Update the header icon count
                SHOP.updateHeaderIcon(data.data);

                // Update the cart if it is present
                if ($('.js-cart')) SHOP.updateCart(data.data);

                // Wait for animations to end before updating conten
                setTimeout(() => {

                    // Remove loading class from the cart
                    $('.cart').classList.remove('loading');

                }, 600);

            }).catch((data) => {
                // Show a message if there is an error
                notyf.error({ message: data.message, icon: false });
            });
        }


        /**
         * 
         * Subtract item from quantity
         * 
         */
        if (event.target.matches('.js-subtract-quantity')) {
            // Get the ID of the item
            let id = event.target.dataset.id;
            let variation_id = event.target.dataset.variationId || null;

            // Add loading class to the cart
            $('.cart').classList.add('loading');

            // Get the quantity to see if we need to apply an animation
            let $quantity = event.target.parentNode.parentNode.querySelector('input');
            let quantity = parseInt($quantity.value) - 1;

            // Add removal animation to the item
            if (quantity <= 0) $(`.cart__list__item[data-id="${id}"]`).classList.add('cart__list__item--removed');

            // Update the input field
            SHOP.subtractQuantity(event);

            // Remove the item from the card
            SHOP.quickRemove(id, variation_id).then((data) => {

                // Update the sidebar
                SHOP.updateSidecart(data.data);

                // Update the header icon count
                SHOP.updateHeaderIcon(data.data);

                // Update the cart if it is present
                if ($('.js-cart')) SHOP.updateCart(data.data);

                // Wait for animations to end before updating content
                setTimeout(() => {

                    // Remove loading class from the cart
                    $('.cart').classList.remove('loading');

                }, 600);

            }).catch((data) => {
                // Show a message if there is an error
                notyf.error({ message: data.message, icon: false });
            });
        }


        /**
        * 
        * Decrease quantity
        * 
        */
        if (event.target.matches('.js-decrease-quantity')) {

            // Get the input field
            let input = event.target.parentNode.querySelector('input');

            // Update the value whilst respecting the minimum value
            input.value = (input.value > 2) ? parseInt(input.value) - 1 : 1;
        }


        /**
        * 
        * Increase quantity
        * 
        */
        if (event.target.matches('.js-increase-quantity')) {

            // Get the input field
            let input = event.target.parentNode.querySelector('input');

            // Update the value whilst respecting the maximum value
            input.value = (input.value < 100) ? parseInt(input.value) + 1 : 100;
        }


        /**
         * 
         * Add item to quantity
         * 
         */
        if (event.target.matches('.js-add-quantity')) {

            // Get the ID of the item
            let id = event.target.dataset.id;
            let variation_id = event.target.dataset.variationId || null;

            // Add loading class to the cart
            if ($('.cart')) $('.cart').classList.add('loading');


            // Add to cart
            SHOP.quickAdd(id, variation_id).then((data) => {

                if (data.code !== 400) {

                    // Update the input field
                    SHOP.addQuantity(event);

                    // Update the sidebar
                    SHOP.updateSidecart(data.data);

                    // Update the header icon count
                    SHOP.updateHeaderIcon(data.data);

                    // Update the cart if it is present
                    if ($('.js-cart')) SHOP.updateCart(data.data);

                } else {

                    // Show a success message
                    notyf.success({ message: data.message, icon: false });

                }

                // Wait for animations to end before updating content
                setTimeout(() => {

                    // Remove loading class from the cart
                    if ($('.cart')) $('.cart').classList.remove('loading');

                }, 600);

            }).catch((data) => {

                console.log('---')
                console.log(data)
                console.log('---')


                // Remove loading class from the cart
                if ($('.cart')) $('.cart').classList.remove('loading');

                // Show a message if there is an error
                notyf.error({ message: data.message, icon: false });
            });

        }


        /**
         * 
         * Add item to your watchlist
         * 
         */
        if (event.target.matches('.js-toggle-item-from-wishlist')) {

            // Get the ID of the item
            let id = event.target.dataset.id;

            // Get the item being toggled
            let item = $(`.heart[data-id="${id}"]`);

            // Figure out if we need to add or remove the item                
            let type = (item.classList.contains('hearted')) ? 'remove' : 'add';

            if (type === 'add') {

                let name = id;

                if (event.target.parentNode.classList.contains('product-card__wishlist')) {
                    name = event.target.parentNode.querySelector('.products__actions__grid__item__details__title b').innerHTML;
                }

                if (event.target.parentNode.classList.contains('product__wrap__gallery')) {
                    name = event.target.closest('.product__wrap').querySelector('.product__wrap__heading h1').innerHTML;
                }

                if (event.target.parentNode.classList.contains('featured-slider__slider__carousel__item__inner')) {
                    name = event.target.closest('.featured-slider__slider__carousel__item__inner').querySelector('.featured-slider__slider__carousel__item__inner__details__title').innerHTML;
                }

                if (event.target.parentNode.classList.contains('featured-range__slider__item')) {
                    name = event.target.closest('.featured-range__slider__item').querySelector('.featured-range__slider__item__details__title b').innerHTML;
                }

                window.dataLayer = window.dataLayer || [];
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: 'add_to_wishlist',
                    ecommerce: {
                        'currencyCode': 'AUD',
                        items: [
                            {
                                item_id: id,
                                item_name: name,
                                quantity: 1
                            }
                        ]
                    }
                });
            }

            let isWishlistPage = document.body.classList.contains('Toast\\Pages\\WishlistPage');

            // Toggle the heart animation class
            item.classList.toggle('hearted');

            if (isWishlistPage) {

                // Add loading class to the cart
                $('.wishlist').classList.add('loading');

                // Toggle the heart animation class
                item.parentNode.parentNode.classList.add('wishlist__list__item--removed');
            }

            SHOP.toggleItemFromWishlist(id, type)
                .then((data) => {
                    notyf.success({ message: data.message, icon: false });

                    // Update our wishlist array
                    window.wishlist = data.data.items.map(item => item.id);

                    // Update the header icon count
                    SHOP.updateWishlistIcon(window.wishlist);

                    if (isWishlistPage) {
                        // Wait for animations to end before updating content
                        SHOP.updateWishlistPage(data);

                        setTimeout(() => {
                            // Remove loading class from the cart
                            $('.wishlist').classList.remove('loading');
                        }, 600);
                    }

                })
                .catch((data) => {
                    notyf.error({ message: data.message, icon: false });
                });


        }


        /**
         * 
         * Noop
         * 
         */
        if (event.target.matches('.js-disable-click')) {
            event.preventDefault();
        };

        /**
         * 
         * Add item to your cart
         * 
         */
        if (event.target.matches('.js-add-to-cart')) {

            event.preventDefault();

            // Add a loading class to the button
            event.target.classList.add('busy');

            // GA4 ecommerce tracking
            let variation_id = event.target.dataset.variant;
            let variations = window.product_data.variations;
            let variation = null;

            if (variations.length) {
                variation = variations.filter(variation => {
                    if (variation.id === parseInt(variation_id)) return variation;
                });
            }

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                'event': 'add_to_cart',
                'ecommerce': {
                    'currencyCode': 'AUD',
                    'value': ((parseInt(event.target.parentNode.parentNode.parentNode.querySelector('input').value)) * ((variation === null) ? window.product_data.price : variation[0].price)),
                    'add': {
                        'products': [{
                            'name': window.product_data.title,
                            'id': (variation === null) ? window.product_data.code : variation[0].code,
                            'price': (variation === null) ? window.product_data.price : variation[0].price,
                            'category': window.product_data.range,
                            'variant': (variation === null) ? window.product_data.id : variation[0].id,
                            'quantity': parseInt(event.target.parentNode.parentNode.parentNode.querySelector('input').value)
                        }]
                    }
                }
            });

            // TODO: at some stage the specificity here needs to be improved
            SHOP.addToCart(event.target.dataset.apiUrl,
                parseInt(event.target.parentNode.parentNode.parentNode.querySelector('input').value),
                event.target
            ).then((data) => {

                // Show a success message
                notyf.success({ message: data.message, icon: false });

                // Only update DOM elements on success
                if (data.code !== 400) {

                    // Update the sidebar
                    SHOP.updateSidecart(data.data);

                    // Update the header icon count
                    SHOP.updateHeaderIcon(data.data);
                }

                // Remove the loading class frmo the button
                setTimeout(() => event.target.classList.remove('busy'), 100);

            }).catch((data) => {

                // Remove the loading class frmo the button
                setTimeout(() => event.target.classList.remove('busy'), 100);

                notyf.error({ message: data.message, icon: false });
            });
        }



        /**
         * 
         * Move a wishlist item to your cart
         * 
         */
        if (event.target.matches('.js-move-to-cart')) {
            event.preventDefault();

            // Add a loading class to the button
            event.target.classList.add('busy');

            // Add loading class to the cart
            $('.wishlist').classList.add('loading');

            // Toggle the heart animation class
            event.target.parentNode.parentNode.parentNode.classList.add('wishlist__list__item--removed');

            SHOP.moveToCart(event.target.getAttribute('href')).then((data) => {

                // Show a success message
                notyf.success({ message: data.message, icon: false });

                // Wait for animations to end before updating content
                SHOP.updateWishlistPage(data);

                // Fetch the updated cart
                SHOP.fetchCart().then((data) => {

                    // Update the sidecart
                    SHOP.updateSidecart(data.data);

                    // Update the header icon count
                    SHOP.updateHeaderIcon(data.data);

                    // Update the cart window variable
                    window.cart = data.data;

                });

                // Fetch the updated wishlist
                SHOP.fetchWishlist().then((data) => {

                    // Store our wislist globally
                    window.wishlist = data.data.items;

                    // Update the header icon count
                    SHOP.updateWishlistIcon(data.data.items);

                });

                // Add loading class to the cart
                setTimeout(() => $('.wishlist').classList.remove('loading'), 400);

                // Remove the loading class frmo the button
                setTimeout(() => event.target.classList.remove('busy'), 100);

            }).catch((data) => {
                notyf.error({ message: data.message, icon: false });
            });
        }

    }, false);


    /**
     * 
     * Update cart on page load
     * 
     */
    SHOP.fetchCart().then((data) => {

        // Update the sidecart
        SHOP.updateSidecart(data.data);

        // Update the header icon count
        SHOP.updateHeaderIcon(data.data, false);

        // Update the sidecart if we are on the checkout page
        if (document.body.dataset.segment === 'checkout') SHOP.updateCheckout(data.data);

        // Update the cart window variable
        window.cart = data.data;

    });

    /*------------------------------------------------------------------
    Update the wishlist items on page load
    ------------------------------------------------------------------*/

    SHOP.fetchWishlist().then((data) => {

        // Store our wislist globally
        window.wishlist = data.data.items;

        // Update the header icon count
        SHOP.updateWishlistIcon(data.data.items, false);
    });

    /*------------------------------------------------------------------
    Data adjustments - to add measurements to the product page
    ------------------------------------------------------------------*/

    let adjustments = document.querySelectorAll('[data-adjustment]');

    adjustments.forEach(adjustment => {

        // Add mm to the bath size if it is not present
        if (adjustment.dataset.adjustment === 'Bath size' && !adjustment.innerHTML.includes('mm')) {
            adjustment.innerHTML = adjustment.innerHTML + 'mm';
        }

        // Add kg to the weight if it is not present
        if (adjustment.dataset.adjustment === 'Weight' && !adjustment.innerHTML.includes('kg')) {
            adjustment.innerHTML = adjustment.innerHTML + 'kg';
        }

        // Add L to the bowl capacity if it is not present
        if (adjustment.dataset.adjustment === 'Bowl capacity' && !adjustment.innerHTML.includes('L')) {
            adjustment.innerHTML = adjustment.innerHTML + 'L';
        }

        // Change booleans to Yes or No 
        if (adjustment.dataset.adjustment === 'Overflow') {

            // Change a 0 to a No
            if (adjustment.innerHTML === '0') adjustment.innerHTML = 'No';

            // Change a 1 to a Yes
            if (adjustment.innerHTML === '1') adjustment.innerHTML = 'Yes';
        }

    });

    /*------------------------------------------------------------------
    Footer subscription form
    ------------------------------------------------------------------*/
    let once = false;
    let captcha;
    $$('#subscriptionForm input').forEach(input => {
        input.addEventListener('focus', (event) => {
            $('.footer').classList.add('active');
            if (!once) {
                captcha = grecaptcha.render("submit",
                    {
                        sitekey: window.recaptcha_site_key,
                        callback: (response) => {
                            onSubmit(response);
                        }
                    }
                ); once = true;
            }
        });

    });


    var onSubmit = (token) => {
        event.preventDefault();

        let subscriptionForm = $("#subscriptionForm");

        let data = {
            'Name': $('#subscription_name').value,
            'Email': $('#subscription_email').value,
            'g-recaptcha-response': token,
        };

        fetch(subscriptionForm.getAttribute('action'), {
            method: 'POST',
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .then((data) => {

                // Show a success message
                notyf.success({ message: data.message, icon: false });

                // Reset the form
                subscriptionForm.reset();


            })
            .catch((data) => {
            });
    };

});

